import React from 'react'
import { Table } from "reactstrap";
import './WorksheetDetails.css'

const WorksheetDetails = (props) => {
    return (

        <div className='Worksheet-Details'>
            <button className='button'>SAVE WORKSHEET</button>
            <button className='button'>DOWNLOAD AS PDF</button>

            <Table className='table'>
                <tbody>
                    <tr>
                        <td>Shared By</td>
                        <td>{props.InputFields.shared_by}</td>
                    </tr>
                    {props.sharedWith.shared_with_list && props.sharedWith.shared_with_list.map((sharedList, index) => {
                        return (
                            <tr key={index}>
                                <td>Shared With</td>
                                <td>{sharedList.shared_to__email}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            <p className='note'>
                Note:<span className='note-data'>{props.Note.weak_attribute}</span> is your weak area in
                <span className='note-data'>{props.Note.orientation}</span>.
                You may want to seek inputs from your
                {props.Note.assessor_groups && props.Note.assessor_groups.map((relation,index) => {
                    return (
                        <span key={index} className='relaton'>{relation.assessor_name},</span>
                    )
                })} when filling out that area below.
            </p>

            {props.InputFields.worksheet_goal && props.InputFields.worksheet_goal.map((data, index) => {
                return (
                    <div key={index}>
                        <p className='heading'><span>{index+1}</span>.{data.attribute__attribute_name}</p>
                        <textarea placeholder={data.attribute__attribute_name} className='input-area' />
                    </div>
                )
            })}
        </div>
    )
}

export default WorksheetDetails



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/WorksheetDetails/WorksheetDetails.jsx